import { render } from "./TitleLine.vue?vue&type=template&id=52472610"
const script = {}

import "./TitleLine.vue?vue&type=style&index=0&id=52472610&lang=less"

import exportComponent from "/workspace/workdir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__